import { Checkbox, Grid, Tooltip, Typography } from '@aloft/toolkit-sui';

import { ChangeEvent } from 'react';
import { Controller, useWatch } from 'react-hook-form';

import { useZodFormContext } from '../../../../hooks/useZodForm.ts';
import { RecommendCompsFormSchema } from '../../types.ts';
import { FilterSection } from './FilterSection.tsx';
import { PROPERTY_TYPE_CHECKBOX_ITEMS } from './propertyTypeOptions.ts';

export const PropertyTypeFilter = () => {
  const { control, setValue } = useZodFormContext<RecommendCompsFormSchema>();
  const selectedRaw = useWatch({ control, name: 'search.filters.propertySubType' });
  const selected = Array.isArray(selectedRaw) ? selectedRaw : [];

  return (
    <FilterSection
      label="Property Type"
      showClear={selected.length > 0}
      onClear={() => setValue('search.filters.propertySubType', [])}
    >
      <Controller
        name="search.filters.propertySubType"
        control={control}
        render={({ field }) => {
          const fieldSelected = (field.value as string[] | undefined) ?? [];

          const handleChange = (value: string) => (e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              field.onChange([...fieldSelected, value]);
            } else {
              field.onChange(fieldSelected.filter((item) => item !== value));
            }
          };

          return (
            <Grid
              alignSelf="stretch"
              gridTemplateColumns="repeat(2, minmax(0, 1fr))"
              gridTemplateRows="repeat(3, fit-content(100%))"
              rowGap="8px"
              columnGap="8px"
              width="100%"
              __dangerDoNotUseSx={{ display: 'inline-grid' }}
            >
              {PROPERTY_TYPE_CHECKBOX_ITEMS.map(({ id, label }) => {
                const isChecked = fieldSelected.includes(id);
                return (
                  <Tooltip key={id} label={`${label} - ${id}`} openDelay={1000}>
                    <Checkbox isChecked={isChecked} onChange={handleChange(id)}>
                      <Typography variant={isChecked ? 'h4' : 'body1'}>{label}</Typography>
                    </Checkbox>
                  </Tooltip>
                );
              })}
            </Grid>
          );
        }}
      />
    </FilterSection>
  );
};
